export enum Currency {
	RUB = 'RUB',
	USD = 'USD',
}
